export default {
    state: {
      data: false,
    },
    getters: {
      //
    },
    actions: {
      resetTutorial(context) {
        context.commit("updateTutorial", false)
      },
    },
    mutations: {
      updateTutorial(state, data) {
        return state.data = data
      }
    }
  }